<!--活动报名-->
<template>
    <div class="parent-container">
        <div class="event-course-container">
            <div class="event-sub-topic-top" v-if="showMode==='view'">
                <div class="event-topic-top-left1">
                    <div class="event-wel-logo cursor" @click="jumpPageNotAuth('/jzedu/wel')">
                        <img class="cursor" style="width: 54px;height: 38px;" src="../../assets/lyjy.png" alt="精准教研">

                    </div>
                </div>
                <div class="event-topic-top-left2">
                    <div class="event-top-left1">
                        <div style="margin-right: 10px;">专题活动</div>
                        <div v-if="info.status===0" class="event-status-info-cs">初始阶段</div>
                        <div v-if="info.status===1" class="event-status-info-bm">报名阶段</div>
                        <div v-if="info.status===2" class="event-status-info-cs">初审阶段</div>
                        <div v-if="info.status===3" class="event-status-info-fs">复审阶段</div>
                        <div v-if="info.status===4" class="event-status-info-zs">终审阶段</div>
                        <div v-if="info.status===5" class="event-status-info-zs">现场评比</div>
                        <div v-if="info.status===6" class="event-status-info-js">活动结束</div>
                    </div>
                    <div class="event-top-left2">
                        <span v-if="info.status===0||info.status===1">报名阶段&nbsp;&nbsp; {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}</span>
                        <span v-if="info.status===2">初审阶段&nbsp;&nbsp; {{ timestampToTime(info.csBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.csEndTime)}}</span>
                        <span v-if="info.status===3">复审阶段&nbsp;&nbsp; {{ timestampToTime(info.fsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.fsEndTime)}}</span>
                        <span v-if="info.status===4">终审阶段&nbsp;&nbsp; {{ timestampToTime(info.zsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.zsEndTime)}}</span>
                        <span v-if="info.status===5">现场评比&nbsp;&nbsp; {{ timestampToTime(info.evaBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.evaEndTime)}}</span>
                        <span v-if="info.status===6">活动结束</span>
                    </div>
                </div>
                <div class="event-topic-top-right">
                    <!--报名阶段-->
                    <div class="event-right-ntn" style="margin-left: 240px">
                        <div class="event-bm-btn" @click="raceSignUp">报名资料</div>
                    </div>
                </div>
            </div>
            <!--详情-->
            <div class="event-topic-detail" v-if="showMode==='view'">
                <div class="event-topic-container">
                    <div class="event-topic-name-container">
                        {{info.activityName}}
                    </div>

                    <div class="event-topic-time-container">
                        <div class="event-topic-time-top">
                            <div class="event-topic-time-top1">
                                <svg t="1745994882084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9405" width="18" height="18"><path d="M597.333333 618.666667h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM597.333333 832h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667zM277.333333 618.666667H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM277.333333 832H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667z" p-id="9406" fill="#ff7f2e"></path><path d="M874.666667 85.333333h-128V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-298.666666V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-128C89.6 85.333333 42.666667 132.266667 42.666667 192v725.333333C42.666667 977.066667 89.6 1024 149.333333 1024h725.333334c59.733333 0 106.666667-46.933333 106.666666-106.666667v-725.333333C981.333333 132.266667 934.4 85.333333 874.666667 85.333333zM128 192c0-12.8 8.533333-21.333333 21.333333-21.333333h128v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h298.666666v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h128c12.8 0 21.333333 8.533333 21.333333 21.333333V341.333333H128V192z m768 725.333333c0 12.8-8.533333 21.333333-21.333333 21.333334h-725.333334c-12.8 0-21.333333-8.533333-21.333333-21.333334V426.666667h768v490.666666z" p-id="9407" fill="#ff7f2e"></path></svg>
                            </div>
                            <div class="event-topic-time-top2">
                                活动时间安排
                            </div>
                        </div>

                        <div class="event-topic-jd">
                            <div class="event-topic-jd1">
                                <div class="event-topic-point"></div>
                            </div>
                            <div :class="info.status===1?'event-topic-jd2 event-time-active':'event-topic-jd2'">报名阶段</div>
                        </div>
                        <div :class="info.status===1?'event-topic-jd-time event-time-active':'event-topic-jd-time'">
                            {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}
                        </div>

                        <div class="event-topic-jd" v-if="info.checkMode==='2'||info.checkMode==='3'">
                            <div class="event-topic-jd1">
                                <div class="event-topic-point"></div>
                            </div>
                            <div :class="info.status===2?'event-topic-jd2 event-time-active':'event-topic-jd2'">初审阶段</div>
                        </div>
                        <div :class="info.status===2?'event-topic-jd-time event-time-active':'event-topic-jd-time'" v-if="info.checkMode==='2'||info.checkMode==='3'">
                            {{ timestampToTime(info.csBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.csEndTime)}}
                        </div>

                        <div class="event-topic-jd" v-if="info.checkMode==='3'">
                            <div class="event-topic-jd1">
                                <div class="event-topic-point"></div>
                            </div>
                            <div :class="info.status===3?'event-topic-jd2 event-time-active':'event-topic-jd2'">复审阶段</div>
                        </div>
                        <div :class="info.status===3?'event-topic-jd-time event-time-active':'event-topic-jd-time'" v-if="info.checkMode==='3'">
                            {{ timestampToTime(info.fsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.fsEndTime)}}
                        </div>

                        <div class="event-topic-jd">
                            <div class="event-topic-jd1">
                                <div class="event-topic-point"></div>
                            </div>
                            <div :class="info.status===4?'event-topic-jd2 event-time-active':'event-topic-jd2'">终审阶段</div>
                        </div>
                        <div :class="info.status===4?'event-topic-jd-time-end event-time-active':'event-topic-jd-time-end'">
                            {{ timestampToTime(info.zsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.zsEndTime)}}
                        </div>
                    </div>

                    <div class="event-topic-title-container">
                        <div class="event-topic-title-container1">
                            <svg t="1745994994411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10489" width="24" height="24"><path d="M210.823529 839.183059V120.470588H146.040471C114.672941 120.470588 90.352941 152.997647 90.352941 180.976941v787.681883C90.352941 987.030588 100.020706 1024 146.040471 1024h621.492705C782.351059 1024 813.176471 1008.941176 813.176471 968.643765V918.588235H290.590118C245.955765 918.588235 210.823529 872.779294 210.823529 839.183059zM786.808471 180.705882h160.015058L768 0v162.590118c0 12.182588 6.144 18.115765 18.808471 18.115764z" p-id="10490" fill="#ff7f2e"></path><path d="M786.808471 195.764706C765.906824 195.764706 752.941176 183.055059 752.941176 162.590118V0H275.531294C246.287059 0 225.882353 21.443765 225.882353 51.772235L226.123294 120.470588H225.882353v718.712471C225.882353 865.249882 258.514824 903.529412 290.590118 903.529412H881.935059C912.384 903.529412 948.705882 868.201412 948.705882 839.183059V195.764706H786.808471zM813.176471 692.705882H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-225.882353H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-210.823529H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058823s-6.776471 15.058824-15.058823 15.058824z" p-id="10491" fill="#ff7f2e"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            基础信息
                        </div>
                    </div>
                    <div class="event-topic-base-info-container">
                        <div class="event-base-one-container">
                            <div class="event-base-one-info-80">活动名称：<span style="color: #767676">{{info.activityName}}</span></div>
                        </div>
                    </div>
                    <div class="event-topic-base-info-container">
                        <div class="event-base-one-container">
                            <div class="event-base-one-info">活动级别：<span style="color: #767676">{{info.activityLevelName}}</span></div>
                            <div class="event-base-one-info">活动方向：<span style="color: #767676">{{info.activityDirectionName}}</span></div>
                        </div>
                    </div>
                    <div class="event-topic-base-info-container">
                        <div class="event-base-one-container">
                            <div class="event-base-one-info">主办单位：<span style="color: #767676">{{info.hostOrgName}}</span></div>
                            <div class="event-base-one-info">活动负责人：<span style="color: #767676">{{info.activityLeaderName}}</span></div>
                        </div>
                    </div>

                    <div class="event-topic-base-info-container">
                        <div class="event-base-one-container">
                            <div class="event-base-one-info">活动范围：<span style="color: #767676">{{info.activityNatureName}}</span></div>
                            <div class="event-base-one-info">联系方式：<span style="color: #767676">{{info.contactInfo}}</span></div>
                        </div>
                    </div>
                    <!--竞赛介绍文字-->
                    <div class="event-topic-title-container" v-if="info.activityType===0&&info.activityContent">
                        <div class="event-topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            活动介绍
                        </div>
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;"
                         v-if="info.activityType===0&&info.activityContent">
                        为深入贯彻教育强国、强省建设规划纲要精神，全面落实山西省教育科学研究院《关于举办 2026 年高中阶段 “三晋教研大讲堂” 之 AI 赋能课堂教学活动的通知》（晋教科院函〔2026〕24 号）工作要求，依托 “三晋教研大讲堂” 高水平教研交流平台，赋能全市高中教师专业发展，整体提升高中教育教学质量与育人水平，同时立足新课标、新教材、新高考 “三新” 改革背景，以 AI 技术为抓手破解课堂教学改革难点、落实立德树人根本任务，推动县域高中振兴发展、缩小城乡教育差距，搭建市县校三级教研交流桥梁、促进优质教学资源共享与全市高中教研协同发展，经研究，决定组织全市高中学校参加本次省级活动，现将有关事项通知如下：
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;"
                         v-if="info.activityType===0&&info.activityContent">
                        一、活动主题
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;text-indent: 50px;"
                         v-if="info.activityType===0&&info.activityContent">
                        AI 赋能课堂 数智振兴县中
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;"
                         v-if="info.activityType===0&&info.activityContent">
                        二、活动地点
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;text-indent: 50px;"
                         v-if="info.activityType===0&&info.activityContent">
                        报到地点：太原市交通大厦
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;text-indent: 50px;"
                         v-if="info.activityType===0&&info.activityContent">
                        活动地点：太原师范学院附属中学 太原市实验中学
                    </div>

                    <div class="event-topic-title-container"
                         v-if="info.activityType===0&&info.activityRule">
                        <div class="event-topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            报名要求
                        </div>
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;" v-if="info.activityType===0&&info.activityRule">
                        1、参与范围： 全市各高中学校全体教师，重点组织县域高中教师参与，鼓励教师自发创作并上传 AI 赋能课堂教学优秀课例至省级 “课例广场”，集中展示我市 AI 赋能课堂教学的实践成果。
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;" v-if="info.activityType===0&&info.activityRule">
                        2、课例要求： 上传课例须按照省级 “353 教育 AI 赋能范式” 要求，明确 AI 赋能的三种应用模式（协同型、辅助型、启思型），完整呈现工具、功能、方式、作用、效果五个维度的实践内容，同时符合必要性、学科内核性、系统性三项核心原则，突出学科特色与 AI 赋能的实际教学成效。
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;" v-if="info.activityType===0&&info.activityRule">
                        3、材料要求： 参与课例征集的教师须完整填写《2026 年高中阶段 “三晋教研大讲堂” 之 AI 赋能课堂教学活动课例信息统计表》、《AI赋能高中课堂教学课例审核表》，按要求上传统计表，审核表，课例完整视频、教学课件、教学设计（教案）等相关配套材料。各县（区）、市直各高中学校须汇总本单位课例信息，填写《2026 年高中阶段 “三晋教研大讲堂” 之 AI 赋能课堂教学活动课例汇总表》。
                    </div>
                    <div class="event-topic-content-container" style="white-space: pre-wrap;" v-if="info.activityType===0&&info.activityRule">
                        4、上传渠道与时间要求：于2026 年 6 月 15日 24:00 前完成全部课例和相关材料的线上上传工作。
                    </div>

                    <!--竞赛图片-->
                    <div class="event-topic-title-container" v-if="info.activityType===1&&info.imgUrl">
                        <div class="event-topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            竞赛介绍
                        </div>
                    </div>
                    <div class="event-topic-content-container-img" v-if="info.activityType===1&&info.imgUrl">
                        <el-image style="width: 200px; height: 320px;cursor: pointer"
                                  :src="info.imgUrl"
                                  :preview-teleported="true"
                                  :preview-src-list="[info.imgUrl]"
                                  :initial-index="1"
                                  fit="fill" />
                    </div>

                    <div class="event-topic-title-container" v-if="info.fileList&&info.fileList.length>0">
                        <div class="event-topic-title-container1">
                            <svg t="1746001513851" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15262" width="24" height="24"><path d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m128 502.613A128 128 0 0 1 502.613 640l-216.746 98.133L384 521.387A128 128 0 0 1 521.387 384l216.746-98.133z" fill="#ff7f2e" p-id="15263"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            活动附件
                        </div>
                    </div>
                    <div class="event-file-list">
                        <div class="event-file-item" v-for="item in info.fileList" :key="item">
                            <div class="event-file-title" style="text-indent: 30px" @click="downloadFile(item)">{{item.fileName}}</div>
                            <div class="event-file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="event-file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="event-file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                            </div>
                        </div>
                    </div>
                    <!--现场评比-->
                    <div class="event-topic-title-container" v-if="info.isEva===1">
                        <div class="event-topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                        </div>
                        <div class="event-topic-title-container2">
                            现场评比
                        </div>
                    </div>
                    <div class="event-topic-base-info-container" v-if="info.isEva===1">
                        <div class="event-base-one-container">
                            <div class="event-base-one-info-80">评比权重：<span style="color: #767676">{{ info.evaWeight}}%</span></div>
                        </div>
                        <div class="event-base-one-container">
                            <div class="event-base-one-info-80">评比时间：<span style="color: #767676">{{ timestampToTime(info.evaBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.evaEndTime)}}</span></div>
                        </div>
                        <div class="event-base-one-container">
                            <div class="event-base-one-info-80">评比地址：<span style="color: #767676">{{ info.evaAddress}}</span></div>
                        </div>
                        <div class="event-part-container">
                            <div class="event-map-container">
                                <aMap isDetail v-if="isShowMap" ref="zdyMap"
                                      @getGeocoder="getGeocoder"
                                      :oldCenter="oldCenter"
                                      :isShowAMap="true">
                                </aMap>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!--提交报名资料-->
            <div class="event-topic-detail" v-show="showMode==='sign'">
                <div class="event-topic-sign-container">
                    <div class="event-topic-sign-title">活动报名</div>
                    <div class="event-topic-sign-name">
                        {{info.activityName}}
                    </div>
                    <div class="event-topic-sign-form">
                        <el-form ref="signForm" :model="signForm"
                                 :rules="signRules"
                                 label-position="top">
                            <div class="event-topic-sign-title">基本信息</div>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item  prop="username">
                                        <template #label>
                                            教师手机号码
                                            <el-tooltip placement="top" raw-content="true"
                                                        content="如已提交需要修改,可输入手机号码后，点击右侧图标提取资料。<br>此操作会覆盖已填写信息及资料，请谨慎操作。">
                                                <el-icon ><InfoFilled /></el-icon>
                                            </el-tooltip>
                                        </template>
                                        <el-input v-model="signForm.username" placeholder="请输入手机号码"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="1" style="margin-top: 31px;margin-left: 5px;">
                                    <svg @click="queryUserSignInfo" t="1781162943790" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6729" width="30" height="30"><path d="M665.6 51.2h-512v870.4h716.8V256l-204.8-204.8zM800 256h-134.4V121.6L800 256z m19.2 614.4H204.8v-768h409.6v204.8h204.8v563.2z" p-id="6730" fill="#ff7f2e"></path><path d="M512 720c-89.6 0-185.6-25.6-188.8-76.8v-240c0-54.4 96-80 188.8-80 92.8 0 188.8 22.4 188.8 76.8v243.2c0 54.4-99.2 76.8-188.8 76.8z m-150.4-76.8c0 12.8 51.2 38.4 150.4 38.4 96 0 150.4-28.8 150.4-38.4v-70.4c-35.2 19.2-89.6 28.8-150.4 28.8-60.8 0-115.2-9.6-150.4-28.8v70.4z m0-121.6c0 12.8 51.2 38.4 150.4 38.4 96 0 150.4-28.8 150.4-38.4v-70.4c-35.2 16-89.6 28.8-150.4 28.8-60.8 0-115.2-9.6-150.4-28.8v70.4z m150.4-160c-96 0-150.4 28.8-150.4 38.4 0 12.8 51.2 38.4 150.4 38.4 89.6 0 144-25.6 150.4-38.4v-3.2c-3.2-9.6-57.6-35.2-150.4-35.2z" p-id="6731" fill="#ff7f2e"></path></svg>
                                </el-col>
                                <el-col :span="1"></el-col>
                                <el-col :span="11">
                                    <el-form-item label="课例名称" prop="lessonName" >
                                        <el-input v-model="signForm.lessonName" placeholder="请输入课例名称" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item label="教师姓名" prop="trueName">
                                        <el-input v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="1"></el-col>
                                <el-col :span="11">
                                    <el-form-item label="所属学校" prop="orgName">
                                        <el-input v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item label="任教学段" prop="periodKey">
                                        <el-select @change="changePeriod" style="width: 100%;" v-model="signForm.periodKey"
                                                   placeholder="请选择任教学段">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="1"></el-col>
                                <el-col :span="11">
                                    <el-form-item label="任教学科" prop="subjectKey">
                                        <el-select style="width: 100%;" v-model="signForm.subjectKey"
                                                   placeholder="请选择任教学科">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item label="最高学历" prop="qualificationKey">
                                        <el-select style="width: 100%;" v-model="signForm.qualificationKey"
                                                   placeholder="请选择最高学历">
                                            <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="1"></el-col>
                                <el-col :span="11">
                                    <el-form-item label="技术职称" prop="rankLevel">
                                        <el-select style="width: 100%;" v-model="signForm.rankLevel"
                                                   placeholder="请选择技术职称">
                                            <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <div class="event-topic-sign-title">教学设计与实施材料</div>
                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    <span style="color: red">*</span>教案、教学设计
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="jxsjFileList"
                                               :action="serviceUrl+'/authservice/eduActivity/file/uploadFile'"
                                               :headers="{ secret }"
                                               :data="{ fileType: 1}"
                                               accept=".pdf,.ppt,.pptx,.doc,.docx,"
                                               :before-upload="beforeFileUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：&nbsp; PDF &nbsp; PPT &nbsp; Word&nbsp;&nbsp; 大小限制：50M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    <span style="color: red">*</span>教学课件
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="jxkjFileList"
                                               :action="serviceUrl+'/authservice/eduActivity/file/uploadFile'"
                                               :headers="{ secret }"
                                               :data="{ fileType: 2}"
                                               accept=".pdf,.ppt,.pptx,.doc,.docx,"
                                               :before-upload="beforeFileUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：&nbsp; PDF &nbsp; PPT &nbsp; Word&nbsp;&nbsp; 大小限制：50M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    <span style="color: red">*</span>课例信息统计表
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="ssbgFileList"
                                               :action="serviceUrl+'/authservice/eduActivity/file/uploadFile'"
                                               :headers="{ secret }"
                                               :data="{ fileType: 3}"
                                               accept=".pdf,.ppt,.pptx,.doc,.docx,"
                                               :before-upload="beforeFileUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：&nbsp; PDF &nbsp; PPT &nbsp; Word&nbsp;&nbsp; 大小限制：50M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    <span style="color: red">*</span>课例信息审核表
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="shbFileList"
                                               :action="serviceUrl+'/authservice/eduActivity/file/uploadFile'"
                                               :headers="{ secret }"
                                               :data="{ fileType: 7}"
                                               accept=".pdf,.ppt,.pptx,.doc,.docx,"
                                               :before-upload="beforeFileUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：&nbsp; PDF &nbsp; PPT &nbsp; Word&nbsp;&nbsp; 大小限制：50M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-sign-title">教学视频与多媒体资源</div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    <span style="color: red">*</span>课堂实录
                                </div>
                                <div>
                                    <el-upload ref="upload"
                                               v-model:file-list="ktslFileList"
                                               style="width: 100%"
                                               class="upload-demo"
                                               :auto-upload="true"
                                               accept=".mp4,.flv,.wmv,"
                                               :on-remove="handleKtslRemove"
                                               :before-upload="beforeKtslUpload"
                                               :http-request="handleKtslUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：mp4&nbsp;flv&nbsp;wmv &nbsp;&nbsp; 大小限制：2G
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    微课、课例视频
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="wkspFileList"
                                               accept=".mp4,.flv,.wmv,"
                                               :on-remove="handleWkRemove"
                                               :http-request="handleWkUpload"
                                               :before-upload="beforeWkUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：mp4&nbsp;flv&nbsp;wmv &nbsp;&nbsp; 大小限制：500M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    教学资源包
                                </div>
                                <div>
                                    <el-upload class="upload-demo"
                                               v-model:file-list="jxzyFileList"
                                               :action="serviceUrl+'/authservice/eduActivity/file/uploadFile'"
                                               :headers="{ secret }"
                                               :data="{ fileType: 6}"
                                               accept=".pdf,.ppt,.pptx,.doc,.docx,"
                                               :before-upload="beforeFileUpload">
                                        <div style="display: flex">
                                            <div class="event-upload-btn-container">
                                                <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                                <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                            </div>
                                            <div class="event-upload-btn-tip">
                                                支持格式：&nbsp; PDF &nbsp; PPT &nbsp; Word&nbsp;&nbsp; 大小限制：50M
                                            </div>
                                        </div>

                                    </el-upload>
                                </div>
                            </div>

                            <div class="event-topic-file-container">
                                <div class="event-topic-file-item-title">
                                    补充说明
                                </div>
                                <div>
                                    <el-input
                                      v-model="signForm.remarks"
                                      :rows="4"
                                      type="textarea"
                                      placeholder=""
                                    />
                                </div>
                            </div>
                        </el-form>
                        <div class="event-apply-btn-container">
                            <div class="event-apply-btn" @click="submitRaceSign">
                                确定
                            </div>
                            <div class="event-apply-btn-back" @click="backTopicInfo">
                                返回
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--成功-->
            <div class="event-topic-detail" v-show="showMode==='success'">
                <div class="event-success-container">
                    <div class="event-success-content-container">
                        <div class="event-success-icon">
                            <svg t="1748229463840" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3548"><path d="M512 64C265 64 64 265 64 512s201 448 448 448 448-201 448-448S759 64 512 64z m-67 627.4l-0.2-0.2-0.2 0.2-179.2-179.2 45.2-45.2 134.2 134.1 268.6-268.5 45.2 45.2L445 691.4z" fill="#ff7f2e" p-id="3549"></path></svg>
                        </div>
                        <div class="event-success-title">报名资料提交成功</div>
                        <div class="event-success-item-container">
                            <div class="event-success-item-title">活动名称：</div>
                            <div class="event-success-item-content">{{info.activityName}}</div>
                        </div>
                        <div class="event-success-item-container">
                            <div class="event-success-item-title">提交时间：</div>
                            <div class="event-success-item-content">{{ timestampToTime(applyTime)}}</div>
                        </div>
                        <div class="event-success-btn" @click="successConfirm">确定</div>
                    </div>
                </div>
            </div>

            <el-dialog v-model="isAwareShow" width="760px">
                <img alt style="width: 720px;height: 500px" :src="awardUrl"/>
            </el-dialog>

            <!--音视频播放-->
            <el-dialog v-model="isShowVideo" width="76%" top="50px" @close="closeIframe">
                <iframe id="open-video" style="width: 100%;height:calc(100vh - 250px)" :src="videoSrc"
                        frameborder="0"></iframe>
            </el-dialog>
        </div>

        <div class="loading-overlay" v-if="loadingVisible">
            <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="8"></el-progress>
            <p class="tips_css">上传中，请等待...</p>
        </div>
    </div>

</template>
<script>

let OSS = require('ali-oss');
let client = new OSS({
    region: 'oss-cn-beijing',    //创建的时候，bucket所在的区域，华北2->oss-cn-beijing ；其他的可以去百度
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',// 阿里云控制台创建的AccessKey
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1', //阿里云控制台创建的AccessSecret
    bucket: 'free-back'  //创建的bucket的名称
})
/*分片大小*/
const SHARD_SIZE_CONFIG = {
    SMALL: 1, // < 200MB
    MEDIUM: 2, // < 1024MB
    LARGE: 5, // < 2048MB
    X_LARGE_RATIO: 500 // >= 2048MB
};

import {timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import aMap from "@/components/aMap/index.vue";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/activityLink";
import {activityInfo,signUpActivity,infoActivitySignUp,uploadVideo} from "@/api/admin/eduActivity";
import {getFileNameUUID, signatureUrl} from "@/utils/tools";
export default {
    components: {aMap},
    name: "homeEvent",
    data() {
        return {
            timestampToTime,
            serviceUrl,
            isShowMap: false,
            isAwareShow: false,
            loadingVisible: false,
            secret: 'MFwwDQYJKoZIhanNAQEBBQADSwAwSAJBAK0PC8tK0J2I1dnNAs5nBnwAiGF7b6jdkCAwEAQ==',
            viewMode:'view',
            showMode:'view',
            detailMode:'view',
            signModel:'sign',
            fileModel:'info',
            successMode:"success",
            failMode:"fail",
            applyTime:Date.now(),
            infoId:'',
            info:{},
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            //是否已报名
            isApply:0,
            // 表单校验
            delFileList:[],
            oldCenter: [],
            jxsjFileList:[],//教案/教学设计
            jxkjFileList:[],//教学课件
            ssbgFileList:[],//教学实施报告-课例信息统计表
            shbFileList:[],//教学实施报告-课例信息审核表
            ktslFileList:[],//课堂实录
            ktslVideoList:[],//课堂实录
            wkspFileList:[],//微课/课例视频
            wkspVideoList:[],//微课/课例视频
            jxzyFileList:[],//教学资源包
            signForm:{
                activityId:"",
                signType:2,
                trueName:"",
                orgId:"",
                orgName:"",
                periodKey:"",
                subjectKey:"",
                qualificationKey:"",
                rankLevel:"",
                lessonName:"",
                remarks:"",
                fileUrls:"",
                username:"",
            },
            signRules: {
                username: [{ required: true, message: "请输入手机号码", trigger: "blur" },],
                trueName: [{ required: true, message: "请输入真实姓名", trigger: "blur" },],
                orgName: [{ required: true, message: "请输入所属学校", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择任教学段", trigger: "change" },],
                subjectKey: [{ required: true, message: "请选择任教学科", trigger: "change" },],
                qualificationKey: [{ required: true, message: "请选择最高学历", trigger: "change" },],
                rankLevel: [{ required: true, message: "请选择技术职称", trigger: "change" },],
                lessonName: [{ required: true, message: "请输入课例名称", trigger: "blur" },],
            },
            awardUrl:'',
            isShowVideo:false,
            videoSrc:'',
            username:'',
            userInfo:{},
            signInfo:{},
            fileForm:{
                fileName:"",
                fileUrl:"",
                fileType:4,
            },
            partItemSize:5,
            loadingPercentage:0,
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.aid){
            this.infoId = this.$route.query.aid;
            this.getQueryDict();
            this.queryInfo()
        }

    },
    mounted() {},
    methods: {
        /*上传课堂实录*/
        beforeKtslUpload(rawFile){
            if (!(rawFile.type === 'video/mp4' ||
              rawFile.type === 'video/x-flv' ||
              rawFile.type === 'video/x-ms-wmv')) {
                this.$message.error('文件必须是.mp4,.flv,.wmv格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 2048) {
                this.$message.error('文件大小不能超过2G')
                return false
            }
            let fs = rawFile.size / 1024/1024;
            this.partItemSize = this.calcShardSize(fs);
            return true
        },

        handleKtslUpload(option){
            // 文件后缀
            debugger
            var fileType = this.getFileName(option.file.name);
            console.log("文件后缀===="+fileType)
            // 获取文件名称
            var obj = option.file.name
            this.fileForm.fileName = obj;
            console.log("文件名称===="+obj)
            var index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + fileType;
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/courseAnalyse/${objName}`, option.file).then(res => {
                this.loadingVisible = false;
                // 上传成功之后，转换真实的地址
                signatureUrl(`/ygjy/courseAnalyse/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.fileForm.fileUrl = result;
                    this.fileForm.fileType = 4;
                    uploadVideo(this.fileForm).then(res => {
                        if (res.data.code===1){
                            var file = res.data.data;
                            this.ktslVideoList.push({
                                name: file.fileName,
                                fileId: file.fileId,
                                url: file.fileUrl,
                                response: {
                                    code: 1,
                                    data: file.fileUrl
                                }
                            })
                            this.ktslFileList = this.ktslVideoList;
                            this.loadingVisible = false;
                        }else {
                            this.loadingVisible = false;
                        }
                    })

                })
            })
        },
        handleKtslRemove(file, uploadFiles) {
            var list = [];
            this.ktslVideoList.forEach(e => {
                if (!(e.url===file.response.data)){
                    list.push(e)
                }
            })
            this.ktslFileList = list;
            this.ktslVideoList = list;
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await client.multipartUpload(`${ObjName}`, fileUrl, {// 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    // 设置并发上传的分片数量。
                    parallel: 6,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * this.partItemSize,
                })
                // ObjName为文件名字,可以只写名字，就直接储存在 bucket 的根路径，如需放在文件夹下面直接在文件名前面加上文件夹名称
                return result
            } catch (e) {
                if (client) client.cancel();
                this.$message.error('上传失败')
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
        calcShardSize(fileSize) {
            if (fileSize < 200) return SHARD_SIZE_CONFIG.SMALL;   // 1MB
            else if (fileSize < 1024) return SHARD_SIZE_CONFIG.MEDIUM; // 2MB
            else if (fileSize < 2048) return SHARD_SIZE_CONFIG.LARGE;  // 5MB
            else return Math.ceil(fileSize / SHARD_SIZE_CONFIG.X_LARGE_RATIO); // 动态分片
        },
        /*微课课例视频实录*/
        beforeWkUpload(rawFile){
            if (!(rawFile.type === 'video/mp4' ||
              rawFile.type === 'video/x-flv' ||
              rawFile.type === 'video/x-ms-wmv')) {
                this.$message.error('文件必须是.mp4,.flv,.wmv格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 500) {
                this.$message.error('文件大小不能超过500M')
                return false
            }
            let fs = rawFile.size / 1024/1024;
            this.partItemSize = this.calcShardSize(fs);
            return true
        },
        handleWkUpload(option){
            // 文件后缀
            debugger
            var fileType = this.getFileName(option.file.name);
            // 获取文件名称
            var obj = option.file.name
            this.fileForm.fileName = obj;
            var index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + fileType;
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/courseAnalyse/${objName}`, option.file).then(res => {
                this.loadingVisible = false;
                // 上传成功之后，转换真实的地址
                signatureUrl(`/ygjy/courseAnalyse/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.fileForm.fileUrl = result;
                    this.fileForm.fileType = 5;
                    uploadVideo(this.fileForm).then(res => {
                        if (res.data.code===1){
                            var file = res.data.data;
                            this.wkspVideoList.push({
                                name: file.fileName,
                                fileId: file.fileId,
                                url: file.fileUrl,
                                response: {
                                    code: 1,
                                    data: file.fileUrl
                                }
                            })
                            this.wkspFileList = this.wkspVideoList;
                            this.loadingVisible = false;
                        }else {
                            this.loadingVisible = false;
                        }
                    })

                })
            })
        },
        handleWkRemove(file, uploadFiles) {
            var list = [];
            this.wkspVideoList.forEach(e => {
                if (!(e.url===file.response.data)){
                    list.push(e)
                }
            })
            this.wkspFileList = list;
            this.wkspVideoList = list;
        },

        queryUserSignInfo(){
            if (!this.signForm.username){
                this.$message.error("请填写正确的手机号")
                return
            }
            infoActivitySignUp({ activityId: this.infoId,username: this.signForm.username }).then(res => {
                if (res.data.code === 1) {
                    this.signInfo = res.data.data;
                    this.signForm = this.signInfo;
                    this.signForm.username = this.signInfo.userId;
                    queryDict({code: 'archive_xd_xk'}).then(res => {
                        this.periodList = res.data.data;
                        this.subjectList = [];
                        this.periodList.forEach(j => {
                            if (this.signForm.periodKey === j.dictKey) {
                                this.subjectList = j.childrenList;
                            }
                        })
                    })
                    // 教案、教学设计
                    this.jxsjFileList = [];
                    this.signForm.jxsjFileList.forEach(e => {
                        this.jxsjFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 教学课件
                    this.jxkjFileList = [];
                    this.signForm.jxkjFileList.forEach(e => {
                        this.jxkjFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 教学实施报告-统计表
                    this.ssbgFileList = [];
                    this.signForm.ssbgFileList.forEach(e => {
                        this.ssbgFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 教学实施报告-审核表
                    this.shbFileList = [];
                    this.signForm.shbFileList.forEach(e => {
                        this.shbFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 课堂实录
                    this.ktslFileList = [];
                    this.signForm.ktslFileList.forEach(e => {
                        this.ktslFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 课堂实录-视频信息
                    this.ktslVideoList = [];
                    this.signForm.ktslFileList.forEach(e => {
                        this.ktslVideoList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 微课、课例视频
                    this.wkspFileList = [];
                    this.signForm.wkspFileList.forEach(e => {
                        this.wkspFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 微课、课例视频
                    this.wkspVideoList = [];
                    this.signForm.wkspFileList.forEach(e => {
                        this.wkspVideoList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                    // 教学资源包
                    this.jxzyFileList = [];
                    this.signForm.jxzyFileList.forEach(e => {
                        this.jxzyFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code: 1,
                                data: e.fileUrl
                            }
                        })
                    })
                }else {
                    this.$message.error("当前手机号码暂未提交资料")
                }
            });
        },
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        queryInfo(){
            activityInfo({ activityId: this.infoId,username: this.username }).then(res => {
                if (res.data.code===1){
                    this.info = res.data.data;
                    if (this.info.isApply===1){
                        this.isApply = 1;
                        this.signForm = this.info.raceSign;
                        this.signForm.username = this.username;
                        queryDict({ code: 'archive_xd_xk' }).then(res => {
                            this.periodList = res.data.data;
                            this.subjectList = [];
                            this.periodList.forEach(j => {
                                if (this.signForm.periodKey === j.dictKey) {
                                    this.subjectList = j.childrenList;
                                }
                            })
                        })
                        //报名资料
                        // 教案、教学设计
                        this.jxsjFileList = [];
                        this.signForm.jxsjFileList.forEach(e => {
                            this.jxsjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 教学课件
                        this.jxkjFileList = [];
                        this.signForm.jxkjFileList.forEach(e => {
                            this.jxkjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 教学实施报告
                        this.ssbgFileList = [];
                        this.signForm.ssbgFileList.forEach(e => {
                            this.ssbgFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 课堂实录
                        this.ktslFileList = [];
                        this.signForm.ktslFileList.forEach(e => {
                            this.ktslFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 微课、课例视频
                        this.wkspFileList = [];
                        this.signForm.wkspFileList.forEach(e => {
                            this.wkspFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 教学资源包
                        this.jxzyFileList = [];
                        this.signForm.jxzyFileList.forEach(e => {
                            this.jxzyFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                    }
                    // 地图
                    if (this.info.isEva === 1) {
                        this.isShowMap = true
                        this.oldCenter = [this.info.lng, this.info.lat]
                        setTimeout(() => {
                            this.$refs.zdyMap.center = this.oldCenter;
                            this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                        }, 100)
                    }
                }
            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        handleApply() {
            this.reportForm.raceId = this.info.raceId;
            this.toReport = true;
            this.reportForm.achievement = ''
            this.reportForm.leaveWord = ''
            this.delFileList = [];
        },
        beforeFileUpload(rawFile){
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type == 'application/vnd.ms-powerpoint' ||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
              rawFile.type === 'application/msword' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')){
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 50) {
                this.$message.error('文件大小不能超过50M')
                return false
            }
            return true
        },
        changeModel(){
            this.$emit('change-mode', this.pageMode);
        },
        getGeocoder(e) {
            if (this.info.isEva === 1) {
                this.info.lat = e.center[1];
                this.info.lng = e.center[0];
                this.info.address = e.formattedAddress;
            }

        },
        raceSignUp(){
            this.showMode = this.signModel;
        },
        viewSignUp(){
            this.showMode = this.fileModel;
        },
        backTopicInfo(){
            this.queryInfo();
            this.showMode = this.detailMode

        },
        successConfirm(){
            this.backTopicInfo()
        },
        changePeriod() {
            this.signForm.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.signForm.periodKey === j.dictKey) {
                    this.subjectList = j.childrenList;
                }
            })
        },
        submitRaceSign(){
            this.signForm.activityId = this.info.activityId
            const fileList = [];
            // 教案、教学设计
            if (this.jxsjFileList.length === 0) {
                this.$message.error("请上传教案、教学设计")
                return
            }
            this.jxsjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            // 教学课件
            if (this.jxkjFileList.length === 0) {
                this.$message.error("请上传教学课件")
                return
            }
            this.jxkjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            // 教学实施报告-统计表
            if (this.ssbgFileList.length === 0) {
                this.$message.error("请上传课例信息统计表")
                return
            }
            this.ssbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            // 教学实施报告-统计表
            if (this.shbFileList.length === 0) {
                this.$message.error("请上传课例信息审核表")
                return
            }
            this.shbFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            //课堂实录
            if (this.ktslFileList.length === 0) {
                this.$message.error("请上传课堂实录")
                return
            }
            this.ktslFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            //微课、课例视频
            this.wkspFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            //教学资源包
            this.jxzyFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.$refs["signForm"].validate(valid => {
                if (valid) {
                    const obj = JSON.parse(JSON.stringify(this.signForm));
                    obj.fileUrls = fileList.toString();
                    signUpActivity(obj).then(res => {
                        if (res.data.code === 1) {
                            this.showMode = this.successMode;
                        }else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            })
        },
        viewAware(info){
            this.awardUrl = info.awardUrl;
            this.isAwareShow = true;
        },
        openVideo(url){
            this.videoSrc = url;
            this.isShowVideo = true;
        },
        closeIframe() {
            const iframe = document.getElementById("open-video"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
        jumpPageNotAuth(path){
            this.$router.push(path);
        },
    }
}
</script>
<style>
.parent-container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
}
.event-course-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    box-sizing: border-box;
    margin: auto;
    overflow-y: auto!important;
}
.event-wel-logo{
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e7eef6;
    font-size: 20px;
    img {
        width: 70px;
    }
}
.event-topic-detail{
    width: 1000px;
    height: auto;
    margin: auto;
    background-color: #fff;
}
.event-sub-topic-top{
    width: 100%;
    height: 90px;
    background-color: #ff7f2e;
    display: flex;
    position: fixed;
    top: 0;
    z-index: 999;
}
.event-topic-top-left1{
    width: 100px;
    height: 100%;
}
.event-topic-top-left2{
    width: calc(100% - 480px);
    height: 100%;
}
.event-top-left1{
    height: 50px;
    width: 100%;
    color: #fff;
    line-height: 60px;
    text-indent: 30px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
}
.event-status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-status-info-fs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-status-info-zs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.event-top-left2{
    height: 40px;
    width: 100%;
    color: #fff;
    text-indent: 30px;
    font-size: 15px;
    font-weight: bold;
}
.event-topic-top-right{
    width: 380px;
    height: 100%;
    display: flex;
}
.event-right-ntn{
    width: 90px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.event-bm-btn{
    width: 80px;
    height: 30px;
    background-color: #fff;
    color: #ff7f2e;
    font-size: 14px;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
}
.event-right-ntn-auto{
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.event-right-zs-auto{
    width: auto;
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
}
.event-zs-info{
    width: auto;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    height: 40px;
    line-height: 44px;
}
.event-bm-btn-auto{
    width: auto;
    height: 30px;
    background-color: #fff;
    color: #ff7f2e;
    font-size: 14px;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
    padding: 0 10px 0 10px;
}
.event-topic-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-top: 100px;
}
.event-topic-name-container{
    width: 100%;
    height: 50px;
    line-height: 48px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    box-sizing: border-box;
    padding-left: 15px;

}
.event-topic-time-container{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding-left: 30px;
}
.event-topic-time-top{
    width: 100%;
    height: 30px;
    display: flex;
}
.event-topic-time-top1{
    width: 24px;
    height: 30px;
}
.event-topic-time-top2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.event-topic-jd{
    width: 100%;
    height: 24px;
    display: flex;
}
.event-topic-jd1{
    width: 24px;
    height: 30px;
}
.event-topic-point{
    width: 10px;
    height: 10px;
    background-color: #ff7f2e;
    border-radius: 5px;
    margin-top: 6px;
}
.event-topic-jd2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.event-topic-jd-time{
    height: 30px;
    border-left: 2px solid #ff7f2e;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.event-time-active{
    color: #ff7f2e!important;
}
.event-topic-jd-time-end{
    height: 30px;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.event-topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.event-topic-title-container1{
    width: 50px;
    height: 40px;
    padding-left: 16px;
    box-sizing: border-box;
    padding-top: 8px;
}
.event-topic-title-container2{
    width: calc(100% - 50px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.event-topic-base-info-container{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
}
.event-base-one-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.event-base-one-info{
    width: 40%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.event-base-one-info-80{
    width: 80%;
    height: auto;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.event-topic-content-container{
    width: 96%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    text-indent: 30px;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
    word-break: break-all;
    font-weight: bold;
}
.event-topic-content-container-img{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
}
.event-topic-sign-title-second{
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    padding-left: 50px;
    box-sizing: border-box;
}
.event-topic-file-container-second{
    width: calc(100% - 90px);
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-left: 50px;
}
.event-file-item-second{
    display: flex;
    height: 30px;
    width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.event-file-item-second:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.event-file-list{
    width: 100%;
    height: auto;
}
.event-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
    color: #767676;
    font-weight: bold;
}
.event-file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.event-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;

}
.event-file-view{
    width: 30px;
    height: 100%;
}
.event-file-download{
    width: 30px;
    height: 100%;
}
.event-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.event-back-btn-container{
    width: 100%;
    height: 60px;
    background-color: #fff;
    padding-top: 15px;
    box-sizing: border-box;
}
.event-back-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 6px;
    background-color: #ff7f2e;
    font-size: 14px;
    text-align: center;
    color: #fff;
    margin: auto;
    cursor: pointer;
    font-weight: bold;
}
.event-topic-sign-container{
    width: 100%;
    height: auto;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    box-sizing: border-box;
}
.event-topic-sign-title{
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    margin-bottom: 5px;
    margin-top: 5px;
}
.event-topic-sign-name{
    width: 100%;
    height: 30px;
    //line-height: 30px;
    font-size: 15px;
    color: #767676;
}
.event-topic-sign-form{
    width: 100%;
    height: auto;
}
.event-item-title-tio{
    font-size: 14px;
    color: #767676;
    font-weight: normal!important;
    margin-left: 60px;
}
/deep/ .el-form-item{
    //margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#333333!important;
    font-weight:bold;
    font-size:13px
}
.event-topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.event-topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.event-upload-btn-container{
    width: 160px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    display: flex;
}
.event-upload-btn-tip{
    text-indent: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    color: #767676;
}
.event-apply-btn-container-back{
    width: 100%;
    height: 50px;
}
.event-apply-btn-back{
    width: 80px;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.event-apply-btn-container{
    width: 200px;
    height: 40px;
    padding-top: 30px;
    display: flex;
    margin: auto;
}
.event-apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.event-apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}
.event-bg-dsh{
    background-color: #93d2f3;
    color: #fff!important;
}
.event-bg-ytg{
    background-color: #81b336;
    color: #fff!important;
}
.event-bg-wtg{
    background-color: #bd3124;
    color: #fff!important;
}
.event-bg-dj{
    background-color: #ffbf6b;
    color: #fff!important;
}
.event-bg-xc{
    background-color: #93d2f3;
    color: #fff!important;

}
.event-file-list{
    width: 100%;
    height: auto;
}
.event-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 20px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.event-file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.event-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.event-file-view{
    width: 30px;
    height: 100%;
}
.event-file-download{
    width: 30px;
    height: 100%;
}
.event-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
/*申报成功*/
.event-success-container{
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: hidden;
    background-color: #fff;
}
.event-success-content-container{
    width: 40%;
    height: 100%;
    margin: auto;
}
.event-success-title{
    width: 100%;
    height: 80px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    color: #000;
}
.event-success-icon{
    width: 64px;
    height: 124px;
    padding-top: 60px;
    box-sizing: border-box;
    margin: auto;
}
.event-success-item-container{
    width: 100%;
    height: auto;
    display: flex;
    padding-bottom: 5px;
}
.event-success-item-title{
    width: 140px;
    font-size: 15px;
    color: #767676;
    text-align: right;
}
.event-success-item-content{
    width: calc(100% - 140px);
    height: auto;
    line-height: 20px;
    font-size: 15px;
    color: #333;
    text-align: left;
    padding-left: 15px;
    box-sizing: border-box;
}
.event-success-btn{
    width: 100px;
    height: 36px;
    line-height: 36px;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #ff7f2e;
    cursor: pointer;
}
.event-part-container{
    width: 80%;
    padding-top: 10px;
}

.loading-overlay {
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>